module.exports = __webpack_public_path__ + "img/object_remove_src_1.129a0801.webp";